import { NgModule, ErrorHandler, Injector } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LocalStoreManager } from 'src/services/local-store-manager.service';
import { DialogComponent } from './dialog/dialog.component';
import { GlobalErrorHandlerService } from 'src/services/globalerrorhandler.service';
import { AuthInterceptor } from 'src/providers/authInterceptor.service';
import { AuthService } from 'src/services/auth.service';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { AuthGuardService } from 'src/services/authguard.service';
import { ShareModule } from './share.module';
import { ControlsModule } from 'src/core/controls/shared/controls.mudule';
import { ToastrModule } from 'ngx-toastr';
import { SepidzToastComponent } from 'src/core/controls/shared/controls/toaster/sepidztoast.component';
import { DescriptionDialogComponent } from './orderdescription/description-dialog.component';
import { UserIdleModule } from 'angular-user-idle';
import { WebsocketService } from 'src/services/websocket.service';
import { ParsianPosService } from 'src/services/parsianpos.service';
import { PosClearingService } from 'src/services/posclearing.service';
import { InvoiceComponent } from './invoice/invoice.component';
import { PortalModule } from './portal/portal.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { PushNotificationsService } from 'src/services/push.notification.service';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    DialogComponent,
    SepidzToastComponent,
    DescriptionDialogComponent,
    InvoiceComponent
  ],
  imports: [
    // BrowserModule,
    HttpClientModule,
    ToastrModule.forRoot(
      // {toastComponent: SepidzToastComponent, // added custom toast!
      // }
    ),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    BrowserAnimationsModule,
    ShareModule,
    ControlsModule,
    NgxUiLoaderModule,
    PortalModule,
    UserIdleModule.forRoot({ idle: 15, timeout: 5, ping: 3 }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
    // SlideshowModule
    //  ShareModule
  ],
  providers: [
    AuthGuardService,
    HttpClientModule,
    LocalStoreManager,
    GlobalErrorHandlerService,
    PushNotificationsService,
    AuthService,
    WebsocketService,
    ParsianPosService,
    PosClearingService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor, multi: true
    }
  ],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  static injector: Injector;
  constructor(injector: Injector) {
    AppModule.injector = injector;
  }
}
